import { hasAvailabilityInStore } from "@components/try-and-buy/components/stores/utils";
import type { StoreHit } from "@components/try-and-buy/types/store";
import { useVariantsAvailability } from "@hooks/useCartItemsAvailability";
import type { ReactNode } from "react";
import { useHits, useInstantSearch } from "react-instantsearch";
import { useTryAndBuyContext } from "../context";
import type { ProductVariant } from "@lib/product/types";

type Props = {
    selectedVariant: ProductVariant;
    children: ({ isNotAvailable }: { isNotAvailable: boolean; isLoading: boolean }) => ReactNode;
};

export const AvailabilityProvider = ({ children, selectedVariant }: Props) => {
    const { hits } = useHits<StoreHit>();
    const { status } = useInstantSearch();

    const { variants, sku: preselectedSKU } = useTryAndBuyContext();
    const { outOfStockSkus } = useVariantsAvailability(variants);

    const isLoading = status === "loading";

    const skus = variants.map(({ sku }) => sku).filter((sku) => !outOfStockSkus.includes(sku));

    const storeWithAvailability = hits.find((store) =>
        selectedVariant
            ? !outOfStockSkus.includes(preselectedSKU) &&
              hasAvailabilityInStore({
                  variants,
                  selectedSku: preselectedSKU,
                  supplyChannels: store.supplyChannels,
              })
            : skus.find((sku) =>
                  hasAvailabilityInStore({
                      variants,
                      selectedSku: sku,
                      supplyChannels: store.supplyChannels,
                  })
              )
    );

    // eslint-disable-next-line no-extra-boolean-cast
    const isNotAvailable = !Boolean(storeWithAvailability);

    return children({
        isNotAvailable,
        isLoading,
    });
};
